<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-alert
          dense
          type="error"
          outlined
          text
          dismissible
          transition="slide-x-transition"
          class="py-0 text-uppercase"
          v-for="(item, index) in errors"
          :key="index"
        >
          {{ item[0] }}
        </v-alert>
      </v-col>
      <v-col cols="6">
        <v-text-field
          label="Name Customer"
          v-model="name"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          label="Amount Paid"
          v-model="paid"
          type="number"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          label="Date"
          type="date"
          v-model="date"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-btn
          color="primary"
          dark
          :loading="storing"
          @click="update"
        >
          Save
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import CLTRepository from '@/repositories/consumer-loan-transaction.repository'
  import { errorHandler } from '@/extra-functions/store.extra'
  export default {
    name: 'edit-consumer-loan-transaction',
    props: {
      propConsumerLoanId: String,
      propConsumerId: String,
      propConsumerLoanTransaction: Object,
    },
    data () {
      return {
        name: null,
        date: null,
        paid: null,
        storing: false,
        errors: [],
      }
    },
    watch: {
      propConsumerLoanTransaction (data) {
        this.name = data.payer_name
        this.date = data.date_transaction
        this.paid = data.amount_paid
      },
    },
    methods: {
      update () {
        if (!this.storing) {
          this.storing = true
          this.errors = []
          const data = {
            consumer_loan_id: this.propConsumerLoanId,
            payer_name: this.name,
            date_transaction: this.date,
            amount_paid: this.paid,
          }
          const id = this.propConsumerLoanTransaction.id
          const params = {
            consumer: this.propConsumerId,
            consumerLoan: this.propConsumerLoanId,
          }
          CLTRepository.update(params, { id, data })
            .then(() => { this.$emit('close-dialog') })
            .catch(e => { this.errors = errorHandler(e) })
            .then(() => { this.storing = false })
        }
      },
    },
  }
</script>
